import { render, staticRenderFns } from "./install_former.vue?vue&type=template&id=219c501b&"
import script from "./install_former.vue?vue&type=script&lang=js&"
export * from "./install_former.vue?vue&type=script&lang=js&"
import style0 from "./install_former.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports